import axiosInstance from "../axiosInstance";
import { appendWarehouseIds } from "../analyticsWarehouses";

export const supplyChainCostAnalysisService = {
  /**
   * GET /api/metrics/supply-chain-cost-analysis
   * Server resolves client from JWT when present; client_id required for admins.
   * `period` (e.g. "last_7_complete_days") lets the server pick the window in
   * its own business timezone; send it instead of startDate/endDate.
   */
  fetch: async ({
    clientId,
    period,
    startDate,
    endDate,
    channels = [],
    warehouseIds = [],
    skip,
    limit,
    sortField,
    sortDir,
  } = {}) => {
    const params = new URLSearchParams();
    if (clientId) params.set("client_id", clientId);
    if (period) params.set("period", period);
    if (startDate) params.set("start_date", startDate);
    if (endDate) params.set("end_date", endDate);
    (channels || [])
      .filter((value) => value != null && value !== "")
      .forEach((value) => {
        params.append("source_channel[$in][]", value);
      });
    // [] = All warehouses; one id keeps `warehouse_id=`, several use [$in][].
    appendWarehouseIds(params, warehouseIds);
    if (skip != null) params.set("$skip", String(skip));
    if (limit != null) params.set("$limit", String(limit));
    if (sortField) params.set("sort_field", sortField);
    if (sortDir) params.set("sort_dir", sortDir);
    const response = await axiosInstance.get(
      `/metrics/supply-chain-cost-analysis?${params.toString()}`,
    );
    return response.data;
  },
};
